module.exports = __webpack_public_path__ + "img/bianhao.41c985f2.png";